// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-page-title{font-size:1.5rem;font-style:normal;font-weight:700;line-height:2.5rem;padding-bottom:.5rem;padding-top:1.25rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
